export const columnFields = [
	'organization.name',
	//
	'jobName',
	'jobRef',
	//
	'builder.name',
	'project.name',
	'customer.name',
	//
	'jobType.name',
	'requestType.name',
	'requirements.name',
	//
	'createdAt',
	//
	'targetAt',
	'dueAt',
	'designEndedAt',
	//
	'team.salesPerson.name',
	'createdBy.name',
	//
	'stage.name',
	'status.name',
	'assignedTo.name',
	'timeInStatus',
	//
	'transactionSummary',
	//
	'unreadMessages',
] as const;
